export enum AreaVariableType {
  AREA = 'AreaVariableDoubleDTO',
  AREA_STRING = 'AreaVariableStringDTO',
  AREA_DATE = 'AreaVariableDateDTO',
  CUSTOM = 'CustomVariableDoubleDTO',
  CUSTOM_VARIABLE = 'CustomDoubleVariable'
}

export enum RegionType {
  REGION = 'REGION',
  AREA = 'AREA'
}

export enum AreaVariableMassiveStages {
  LOADING_SEASON_AREAS = 'components.area_variable_info.loading-seasons',
  LOADING_AREA_VARIABLES = 'components.area_variable_info.loading-area-variables',
  LOADING_VARIETIES = 'components.area_variable_info.loading-varieties',
  EDITING_AREA_VARIABLES = 'components.area_variable_info.updating-area-variables',
  CREATING_AREA_VARIABLES = 'components.area_variable_info.saving-area-variables',
  DELETING_AREA_VARIABLES = 'components.area_variable_info.deleting-area-variables',
  SAVING_VARIETIES = 'components.area_variable_info.saving-varieties',
  SAVING_DATES = 'components.area_variable_info.saving-dates',
  LOADING_REGION_INFO = 'components.area_variable_info.loading-region-info'
}

export enum SeasonAreaUpdateType {
  EMERGENCY_DATE = 'EmergencyDate',
  VARIETIES = 'Varieties',
  HARVESTING_DATE = 'HarvestingDate',
  PLANTING_DATE = 'PlantingDate'
}

export enum AreaVariableInputType {
  NUMERIC = 'numeric',
  TEXT = 'text',
  DATE = 'date'
}
